import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { ChartLoadingState } from "@/components/charts";

interface ServerPriceChartProps {
  title?: string;
  className?: string;
}

/**
 * Server-side safe version of PriceChart
 * This component renders a loading state during server-side rendering
 * to prevent errors with client-side charting libraries
 */
export function ServerPriceChart({ 
  title = "Grafico Prezzi Metalli", 
  className
}: ServerPriceChartProps) {
  return (
    <Card className={cn("w-full border-metal-light/20 shadow-lg", className)}>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="font-bold text-2xl metal-text tracking-tight">
          {title}
        </CardTitle>
        <div className="flex space-x-1">
          <div className="h-8 w-20 bg-muted rounded-md animate-pulse"></div>
          <div className="h-8 w-20 bg-muted rounded-md animate-pulse"></div>
          <div className="h-8 w-20 bg-muted rounded-md animate-pulse"></div>
        </div>
      </CardHeader>
      <CardContent className="h-96 pt-6">
        <ChartLoadingState />
      </CardContent>
    </Card>
  );
}
